<div class="relative flex items-center gap-4 py-4">
  <div class="absolute top-0 right-0">
    <app-public-cart-remove-button [productId]="id()" />
  </div>

  <div class="size-24 md:size-36">
    <app-image-thumbnail size="full">
      <img
        [alt]="imageAlt()"
        [fill]="true"
        [ngSrc]="imageUrl()"
        class="object-contain"
        loading="lazy" />
    </app-image-thumbnail>
  </div>

  <div class="grid w-full flex-1 grid-cols-1 gap-4 md:grid-cols-5 md:gap-4">
    <div class="col-span-2 flex flex-col gap-2">
      <div>
        @if (slug(); as slug) {
          <app-public-product-name
            [slug]="slug"
            [type]="type()">
            <ng-container
              [ngTemplateOutlet]="contentTemplateRef"
              [ngTemplateOutletContext]="{ hoverable: true }" />
          </app-public-product-name>
        } @else {
          <ng-container
            [ngTemplateOutlet]="contentTemplateRef"
            [ngTemplateOutletContext]="{ hoverable: false }" />
        }

        <ng-template
          #contentTemplateRef
          let-hoverable="hoverable">
          <div
            [class.hover:underline]="hoverable"
            class="font-bold text-gray-400">
            {{ name() }}
          </div>

          @if (subName(); as subName) {
            <div class="text-xs text-gray-400">
              {{ subName }}
            </div>
          }
        </ng-template>

        @for (attribute of attributes(); track attribute.id) {
          <div class="flex gap-1">
            <div class="font-bold">{{ attribute.productAttributeLabel }}:</div>
            <div>
              <app-summernote-html-preview [html]="attribute.value" />
            </div>
          </div>
        }
      </div>
    </div>

    <div class="col-span-3 flex items-center gap-4">
      <div>
        <app-public-cart-quantity-update
          (failureEvent)="handleQuantityChangeFailureEvent($event)"
          (successEvent)="handleQuantityChangeSuccessEvent()"
          [disabled]="status().onlySingleElement"
          [id]="id()"
          [quantity]="quantity()" />
      </div>

      <div class="flex flex-1 flex-col items-end">
        <div class="text-xl font-semibold">
          <app-currency [amount]="price()" />
        </div>

        <div class="flex flex-wrap gap-1 text-xs">
          <span>za sztukę</span>
          <app-currency [amount]="unitPrice()" />
        </div>
      </div>
    </div>
  </div>
</div>

<app-alerts />
